//
// topslider
//////////////////////////////////////////////////////////////////

new Swiper('.top-slider-cont2', {
  loop: true,
  speed: 300,
  centeredSlides : true,
  breakpoints: {
    360:  { slidesPerView: 1.1, spaceBetween: 10, },
    768:  { slidesPerView: 1.5 },
    1024: { slidesPerView: 2 },
    1280: { slidesPerView: 3.25 },
    1440: { slidesPerView: 3 },
    1920: { slidesPerView: 3.25 },
    1921: { slidesPerView: 4.35 }
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
    spaceBetween: 40,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
  autoplay: {
    delay: 10000,
    //disableOnInteraction: true,
  },
  // 画像のプリロードを防ぎ、レイアウト崩れを軽減
  preloadImages: false,
  //DOMの変更を監視、レイアウト再計算
  observer: true,
  observeParents: true,
  // 初期化時にスライドのサイズを設定
  on: {
    init: function () {
      this.slides.forEach(slide => {
        slide.style.width = `${this.width}px`;
      });
    },
  },
  // delay設定
  on: {
    slideChange: function () {
      if (this.realIndex > 0) {
        this.params.autoplay.delay = 9700
      }
    },
  },
});

//////////////////////////////////////////////////////////////////

// top-news-ticker

//////////////////////////////////////////////////////////////////

window.addEventListener('load', () => {
  const newsItems = document.querySelectorAll('.news-item');
  const playPauseBtn = document.getElementById('play-pause-btn');
  const prevBtn = document.querySelector('.custom-prev-btn');
  const nextBtn = document.querySelector('.custom-next-btn');
  
  if (newsItems.length === 0) return;
  
  let currentIndex = 0;
  let isPlaying = true;
  let autoplayTimer = null;
  const DISPLAY_TIME = 5000; // 表示時間
  const FADE_DURATION = 500; // フェード時間
  
  // 初期表示
  newsItems[0].classList.add('active');
  
  // スライド切り替え関数
  function changeSlide(nextIndex) {
    if (nextIndex === currentIndex) return;
    
    const currentItem = newsItems[currentIndex];
    const nextItem = newsItems[nextIndex];
    
    // フェードアウト
    currentItem.classList.add('fade-out');
    
    // フェードアウト完了後にフェードイン
    setTimeout(() => {
      currentItem.classList.remove('active', 'fade-out');
      nextItem.classList.add('active');
      currentIndex = nextIndex;
    }, FADE_DURATION);
  }
  
  // 次のスライドへ
  function nextSlide() {
    const nextIndex = (currentIndex + 1) % newsItems.length;
    changeSlide(nextIndex);
  }
  
  // 前のスライドへ
  function prevSlide() {
    const prevIndex = (currentIndex - 1 + newsItems.length) % newsItems.length;
    changeSlide(prevIndex);
  }
  
  // 自動再生開始
  function startAutoplay() {
    if (autoplayTimer) clearInterval(autoplayTimer);
    autoplayTimer = setInterval(nextSlide, DISPLAY_TIME + FADE_DURATION);
  }
  
  // 自動再生停止
  function stopAutoplay() {
    if (autoplayTimer) {
      clearInterval(autoplayTimer);
      autoplayTimer = null;
    }
  }
  
  // ボタンアイコン更新
  function updateButtonIcon() {
    if (isPlaying) {
      playPauseBtn.classList.remove('is-play');
      playPauseBtn.classList.add('is-pause');
    } else {
      playPauseBtn.classList.remove('is-pause');
      playPauseBtn.classList.add('is-play');
    }
  }
  
  // 初期状態
  updateButtonIcon();
  startAutoplay();
  
  // 一時停止/再生ボタン
  playPauseBtn.addEventListener('click', () => {
    if (isPlaying) {
      stopAutoplay();
      isPlaying = false;
    } else {
      startAutoplay();
      isPlaying = true;
    }
    updateButtonIcon();
  });
  
  // 前へボタン
  prevBtn.addEventListener('click', () => {
    prevSlide();
    stopAutoplay();
    isPlaying = false;
    updateButtonIcon();
  });
  
  // 次へボタン
  nextBtn.addEventListener('click', () => {
    nextSlide();
    stopAutoplay();
    isPlaying = false;
    updateButtonIcon();
  });
  
  // マウスオーバーで一時停止
  const tickerInner = document.querySelector('.top-news-ticker-inner');
  tickerInner.addEventListener('mouseenter', () => {
    if (isPlaying) {
      stopAutoplay();
    }
  });
  
  tickerInner.addEventListener('mouseleave', () => {
    if (isPlaying) {
      startAutoplay();
    }
  });
});

//////////////////////////////////////////////////////////////////

// menu-carousel

//////////////////////////////////////////////////////////////////

var swiper = new Swiper('.menu-carousel', {
    breakpoints: {
    360:  { slidesPerView: 1.4, spaceBetween: 20, slidesOffsetBefore: 20 },
    768:  { slidesPerView: 2.5, spaceBetween: 20, slidesOffsetBefore: 20 },
    1024: { slidesPerView: 3.5, spaceBetween: 20, slidesOffsetBefore: 20 },
    1280: { slidesPerView: 2.5, spaceBetween: 20 },
    1400: { slidesPerView: 3.2, spaceBetween: 20 },
    1600: { slidesPerView: 3.5, spaceBetween: 20 },
    1920: { slidesPerView: 4.5, spaceBetween: 20 }
	},
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
  autoplay: {
    delay: 4000
  }
});
var swiper = new Swiper('.menu-carousel-sm', {
  breakpoints: {
  375:  { slidesPerView: 1.5, spaceBetween: 20, slidesOffsetBefore: 20 },
  768:  { slidesPerView: 3, spaceBetween: 20, slidesOffsetBefore: 20 },
  1024: { slidesPerView: 3, spaceBetween: 20, slidesOffsetBefore: 20 },
  1280: { slidesPerView: 3, spaceBetween: 20 },
  1366: { slidesPerView: 3.5, spaceBetween: 20 },
  1400: { slidesPerView: 3.5,  spaceBetween: 20 },
  1600: { slidesPerView: 4,  spaceBetween: 20 },
  1920: { slidesPerView: 4,  spaceBetween: 20 }
},
navigation: {
  nextEl: '.swiper-button-next',
  prevEl: '.swiper-button-prev'
},
///: {
//  delay: 7000
//},
//loop: true,
scrollbar: {
  el: '.swiper-scrollbar',
  draggable: true
},
});
const swiperPrev = document.getElementsByClassName('swiper-button-prev-a');
const swiperNext = document.getElementsByClassName('swiper-button-next-a');

for (let i = 0; i < swiperPrev.length; i++) {
  swiperPrev[i].addEventListener('click', (e) => {
    //const parent = e.target.parentNode;
    const parent = e.target.closest('.menu-carousel-blk');
    const prev = parent.getElementsByClassName('swiper-button-prev')[0];
    prev.click();
  });
}

for (let i = 0; i < swiperNext.length; i++) {
  swiperNext[i].addEventListener('click', (e) => {
    //const parent = e.target.parentNode;
    const parent = e.target.closest('.menu-carousel-blk');
    const next = parent.getElementsByClassName('swiper-button-next')[0];
    next.click();
  });
}

//////////////////////////////////////////////////////////////////

// product compare

//////////////////////////////////////////////////////////////////

var swiper = new Swiper('.carousel-compare', {
  breakpoints: {
    360: { slidesPerView: 1.8, spaceBetween: 0, slidesOffsetBefore: 20, }, // tb
    768: { slidesPerView: 2.5, spaceBetween: 20, slidesOffsetBefore: 30, }, // tb
    1024: { slidesPerView: 3, spaceBetween: 25, slidesOffsetBefore: 50, }, // mpc
    1280: { slidesPerView: 4, spaceBetween: 30, slidesOffsetBefore: 120, }, // pc
    1400: { slidesPerView: 4, spaceBetween: 30, slidesOffsetBefore: 100, }, // pc
    1600: { slidesPerView: 5, spaceBetween: 20, slidesOffsetBefore: 100, }, // pc
    1920: { slidesPerView: 5, spaceBetween: 30, slidesOffsetBefore: 140, } // wpc3
	},
});

//////////////////////////////////////////////////////////////////

// loop-slider

//////////////////////////////////////////////////////////////////

var swiper = new Swiper('.loop-slider', {
  breakpoints: {
    360:  { slidesPerView: 2, spaceBetween: 10, slidesOffsetBefore: 20, }, // tb
    768:  { slidesPerView: 3, spaceBetween: 20, slidesOffsetBefore: 30, }, // tb
    1024: { slidesPerView: 4, spaceBetween: 25, slidesOffsetBefore: 50, }, // mpc
    1280: { slidesPerView: 5, spaceBetween: 30, slidesOffsetBefore: 120, }, // pc
    1400: { slidesPerView: 6, spaceBetween: 30, slidesOffsetBefore: 100, }, // pc
    1600: { slidesPerView: 7, spaceBetween: 20, slidesOffsetBefore: 100, }, // pc
    1920: { slidesPerView: 8, spaceBetween: 30, slidesOffsetBefore: 140, }
  },
  loop: true, // ループ有効
  //slidesPerView: 3, // 一度に表示する枚数
  speed: 6000, // ループの時間
  //allowTouchMove: false, // スワイプ無効
  autoplay: {
    delay: 0, // 途切れなくループ
  },
});
var swiper = new Swiper('.loop-slider-rev', {
  breakpoints: {
    360:  { slidesPerView: 2, spaceBetween: 10, slidesOffsetBefore: 20, }, // tb
    768:  { slidesPerView: 3, spaceBetween: 20, slidesOffsetBefore: 30, }, // tb
    1024: { slidesPerView: 4, spaceBetween: 25, slidesOffsetBefore: 50, }, // mpc
    1280: { slidesPerView: 5, spaceBetween: 30, slidesOffsetBefore: 120, }, // pc
    1400: { slidesPerView: 6, spaceBetween: 30, slidesOffsetBefore: 100, }, // pc
    1600: { slidesPerView: 7, spaceBetween: 20, slidesOffsetBefore: 100, }, // pc
    1920: { slidesPerView: 8, spaceBetween: 30, slidesOffsetBefore: 140, }
  },
  loop: true, // ループ有効
  //slidesPerView: 3, // 一度に表示する枚数
  speed: 6000, // ループの時間
  //allowTouchMove: false, // スワイプ無効
  autoplay: {
    delay: 0, // 途切れなくループ
    reverseDirection: true,
  },
});






document.addEventListener('DOMContentLoaded', function () {
  
  // 1つ目のスライダー
  const swiper1 = new Swiper('.method-type-prod-slider', {
    loop: false,             
    slidesPerView: 1,        
    spaceBetween: 30,        
    navigation: {
      // 1つ目専用のボタンを指定
      nextEl: '.slider1-next',
      prevEl: '.slider1-prev',
    },
    pagination: {
      // 1つ目専用のページネーションを指定
      el: '.slider1-pagination',
      clickable: true,
    },
  });

  // 2つ目のスライダー
  const swiper2 = new Swiper('.method-type-prod-slider2', {
    loop: false,             
    slidesPerView: 1,        
    spaceBetween: 30,
    //autoHeight: true,     
    navigation: {
      // 2つ目専用のボタンを指定
      nextEl: '.slider2-next',
      prevEl: '.slider2-prev',
    },
    pagination: {
      // 2つ目専用のページネーションを指定
      el: '.slider2-pagination',
      clickable: true,
    },
  });

    const swiper3 = new Swiper('.method-type-prod-slider3', {
    loop: false,             
    slidesPerView: 1,        
    spaceBetween: 30,
    //autoHeight: true,     
    navigation: {
      // 2つ目専用のボタンを指定
      nextEl: '.slider3-next',
      prevEl: '.slider3-prev',
    },
    pagination: {
      // 2つ目専用のページネーションを指定
      el: '.slider3-pagination',
      clickable: true,
    },
  });

  const swiper4 = new Swiper('.method-type-prod-slider4', {
    loop: false,             
    slidesPerView: 1,        
    spaceBetween: 30,
    //autoHeight: true,     
    navigation: {
      // 2つ目専用のボタンを指定
      nextEl: '.slider4-next',
      prevEl: '.slider4-prev',
    },
    pagination: {
      // 2つ目専用のページネーションを指定
      el: '.slider4-pagination',
      clickable: true,
    },
  });
  
});